import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  LinearProgress,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, doc, getDoc, updateDoc } from "firebase/firestore";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import { storage } from "../../services/firebase";
import {
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithPopup,
} from "firebase/auth";
import { rescanButton } from "./styles";
import SignaturePad from "react-signature-pad-wrapper";
import {
  BarcodeFormat,
  BrowserMultiFormatReader,
  DecodeHintType,
} from "@zxing/library";

import {
  acceptButton,
  authButton,
  backButton,
  bodyContainer,
  borderLinearProgress,
  buttonContainer,
  checkBoxContainer,
  checkBoxText,
  clearButton,
  container,
  divider,
  googleButton,
  gradeItemContainer,
  gradeText,
  imageContainer,
  imgButtonContaier,
  informationContainer,
  input,
  itemText,
  legalContainer,
  modalContainer,
  nextButton,
  saveButton,
  signatureContainer,
  subContainer,
  subTitle,
  termsContainer,
  termsText,
  titleContainer,
  titleText,
} from "./styles";
import { ReactComponent as GoogleIcon } from "../../assets/icons/ic_google.svg";
import { colors } from "../../theme/colors";
import CertiSampleImg from "../../assets/imgs/certificateofregistration_sample.png";
import RoadworthySampleImg from "../../assets/imgs/roadworthy_sample.png";
import OperatorCardSampleImg from "../../assets/imgs/operator_sample.png";
import BarcodeSampleImg from "../../assets/imgs/barcode_sample.png";
import CameraImg from "../../assets/icons/ic_camera.png";
import ImageUpload from "../../components/ImageUploadView/ImageUpload";
import { getErrorMessage, showToast } from "../../services/toast";
import { isEmpty } from "../../utils";
import { auth, db } from "../../services/firebase";
import { FireBaseDataUpdate, ImageType, InspectionPictureLocations, InspectionPictureType, InspectionsType, UserType } from "../../types";
import BarCodeReader from "../../components/BarCodeReader/BarCodeReader";
import FrontLeftDoorImg from "../../assets/imgs/img_front_left_door_panel.png";
import FrontSeatsImg from "../../assets/imgs/img_front_seats.png";
import FrontRightImg from "../../assets/imgs/img_front_right.png";
import FrontRoofImg from "../../assets/imgs/img_front_roof.png";
import FrontLeftImg from "../../assets/imgs/img_front_left.png";
import RearLeftImg from "../../assets/imgs/img_rear_left.png";
import RearRoofImg from "../../assets/imgs/img_back_roof.png";
import RearRightImg from "../../assets/imgs/img_rear_right.png";
import RearLeftDoorImg from "../../assets/imgs/img_rear_left_door_panel.png";
import RearSeatsImg from "../../assets/imgs/img_rear_seats.png";
import BootInteriorImg from "../../assets/imgs/img_boot.png";
import RearRightDoorImg from "../../assets/imgs/img_rear_right_door_panel.png";
import FrontDashImg from "../../assets/imgs/img_front_dash.png";
import InteriorCeilingImg from "../../assets/imgs/img_ceiling.png";
import FrontRightDoorImg from "../../assets/imgs/img_front_right_door_panel.png";
import OdometerImg from "../../assets/imgs/img_mileage.png";
import {
  accessoryItems,
  locationList,
  vehicleYearList,
  vehicleYears,
} from "../../constants";
import LoadingView from "../../components/LoadingView/LoadingView";




const UserInformation = () => {
  const [firstName, setFirstName] = useState<string>("");
  const [basePicturePath, setBasePicturePath] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [confirmEmail, setConfirmEmail] = useState<string>("");
  const [password, setPassowrd] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const [licenseNumber, setLicenseNumber] = useState<string>("");
  const [vin, setVin] = useState<string>("");
  const [engineNumber, setEngineNumber] = useState<string>("");
  const [vehicleYear, setVehicleYear] = useState<string>("");
  const [vehicleHistory, setVehicleHistory] = useState<string>("");
  const [vehicleTareWeight, setVehicleTareWeight] = useState<string>("");
  const [vehicleType, setVehicleType] = useState<string>("");
  const [cardNumber, setCardNumber] = useState<string>("");
  const [make, setMake] = useState<string>("");
  const [model, setModel] = useState<string>("");
  const [step, setStep] = useState<number>(0);
  const [barCodeScannerOpen, setBarCodeScannerOpen] = useState<boolean>(false);
  const [webcamType, setWebcamType] = useState<string>("");
  const [certificationImgSrc, setCertificationImgSrc] = useState<string>("");
  const [roadworthyDiscSrc, setRoadworthyDiscSrc] = useState<string>("");
  const [operatorCardSrc, setOperatorCardSrc] = useState<string>("");
  const [barCode, setBarCode] = useState<string>("");
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [userId, setUserId] = useState<string>("");
  const [isLogin, setIsLogin] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [inspectId, setInspectId] = useState<string>("");
  const [frontRightSrc, setFrontRightSrc] = useState<string>("");
  const [frontRoofSrc, setFrontRoofSrc] = useState<string>("");
  const [vehicleColor, setVehicleColor] = useState<string>("");
  const [frontLeftSrc, setFrontLeftSrc] = useState<string>("");
  const [rearLeftSrc, setRearLeftSrc] = useState<string>("");
  const [hasRoofRack, setHasRoofRack] = useState<boolean>(false);
  const [hasSunRoof, setHasSunRoof] = useState<boolean>(false);
  const [hasPanoramicRoof, setHasPanoramicRoof] = useState<boolean>(false);
  const [rearRoofSrc, setRearRoofSrc] = useState<string>("");
  const [rearRightSrc, setRearRightSrc] = useState<string>("");
  const [leftDoorSrc, setLeftDoorSrc] = useState<string>("");
  const [frontSeatsSrc, setFrontSeatsSrc] = useState<string>("");
  const [interiorColor, setInteriorColor] = useState<string>("");
  const [rearLeftDoorSrc, setRearLeftDoorSrc] = useState<string>("");
  const [rearSeatsSrc, setRearSeatsSrc] = useState<string>("");
  const [bootInteriorSrc, setBootInteriorSrc] = useState<string>("");
  const [rearRightDoorSrc, setRearRightDoorSrc] = useState<string>("");
  const [frontDashSrc, setFrontDashSrc] = useState<string>("");
  const [interiorCeilingSrc, setInteriorCeilingSrc] = useState<string>("");
  const [interiorType, setInteriorType] = useState<string>("");
  const [frontRightDoorSrc, setFrontRightDoorSrc] = useState<string>("");
  const [odometerSrc, setOdometerSrc] = useState<string>("");
  const [mileage, setMileage] = useState<string>("");
  const [accessories, setAccessories] = useState<string[]>([]);
  const [exteriorGrade, setExteriorGrade] = useState<string>("");
  const [interiorGrade, setInteriorGrade] = useState<string>("");
  const [isSigned, setIsSigned] = useState<boolean>(false);
  const [signatureOpen, setSignatureOpen] = useState(false);
  const [signatureSrc, setSignatureSrc] = useState<string>("");
  const [signatureData, setSignatureData] = useState<string>("");
  const [isCheckedLegal, setIsCheckedLegal] = useState<boolean>(false);
  const [currentTimeStamp, setCurrentTimeStamp] = useState<number>(0);
  const [detectCount, setDetectCount] = useState<number>(0);
  const [expireDate, setExpireDate] = useState<string>("");
  const [isScaned, setIsScaned] = useState<boolean>(false);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const currentId = params.get("id");
  const currentStep = params.get("currentStep");

  const navigate = useNavigate();
  const signaturePadRef = React.createRef<SignaturePad>();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });

  const hints = new Map();
  const formats = [BarcodeFormat.PDF_417];
  hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
  const codeReader = new BrowserMultiFormatReader(hints);

  useEffect(() => {
    let tempStep = localStorage.getItem("step");
    if (tempStep === "1") {
      setStep(1);
    }
  }, []);

  useEffect(() => {
    getUserlocation();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setUserId(uid);
        setIsLogin(true);
      } else {
        console.log("user is logged out");
      }
    });
  }, []);

  useEffect(() => {
    //console.log(`User id changed to: ${userId} insp: ${inspectId} ${!inspectId} curr: ${currentId} ${!currentId}`);
    if (userId && !inspectId && (!currentId || currentId == 'null')) {
      console.log('creating inspection');
      addUserInspectionsData()
    };
  }, [userId, inspectId, currentId])

  useEffect(() => {
    setBasePicturePath(`users/${userId}/inspectionPictures/${inspectId}`);
  }, [userId, inspectId])

  useEffect(() => {
    const handlePopState = (event: { preventDefault: () => void }) => {
      event.preventDefault();
      setSignatureOpen(false);
      if (step > 0) {
        setStep((preStep) => preStep - 1);
      } else {
        navigate("/services");
      }
    };
    window.addEventListener("popstate", handlePopState);
    window.history.pushState({ modalOpened: false }, "");

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [step]);

  useEffect(() => {
    if (!isEmpty(inspectId) && step !== 0) {
      navigate(`/inspection?id=${inspectId}&currentStep=${step}`);
    } else {
      if (step > 0) {
        navigate(`/inspection?id=${currentId}&currentStep=${step}`);
      }
    }
  }, [step]);

  useEffect(() => {
    if (!isEmpty(userId) && currentId) {
      getInspection();
    }
  }, [userId, currentId]);

  const getInspection = async () => {
    setIsLoading(true);
    const docRef = doc(db, `users/${userId}/inspections/${currentId}`);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      let one = docSnap.data() as InspectionsType;

      if (one.paid) {
        showToast('Already paid');
        return navigate('/');
      }
      setSignatureSrc(one.clientSignature?.url ? one.clientSignature.url : "");
      setBarCode(one.vehicleBarcode ? one.vehicleBarcode : "");
      setLocation(one.location || "");
      setLicenseNumber(one.numberPlate || "");
      setVin(one.vin || "");
      setEngineNumber(one.engineNumber || "");
      setVehicleTareWeight(
        `${one.vehicleTareWeight === 0 ? "" : one.vehicleTareWeight}` || ""
      );
      setVehicleHistory(one.vehicleHistory || "");
      setVehicleYear(one.year || "");
      setVehicleType(one.vehicleType || "");
      setCardNumber(one.operatorCard || "");
      setMake(one.make || "");
      setModel(one.model || "");
      setExpireDate(one.lastRoadworthyTestString || "");
      setRoadworthyDiscSrc(one.pictureOfRoadworthyDisc?.url || "");
      setCertificationImgSrc(one.pictureOfCertificateOfRegistration?.url || "");
      setOperatorCardSrc(one.pictureOfOperatorCard?.url || "");
      setFrontRightSrc(one.pictureOfCar?.url || "");
      setFrontRoofSrc(one.pictureOfFrontRoof?.url || "");
      setVehicleColor(one.colour || "");
      setFrontLeftSrc(one.pictureOf45DegreeLeft?.url || "");
      setRearLeftSrc(one.pictureOf45DegreeBackLeft?.url || "");
      setHasRoofRack(one.hasRoofRack || false);
      setHasSunRoof(one.hasSunRoof || false);
      setRearRoofSrc(one.pictureOfRearRoof?.url || "");
      setRearRightSrc(one.pictureOf45DegreeBackRight?.url || "");
      setHasPanoramicRoof(one.hasPanoramicRoof || false);
      setLeftDoorSrc(one.pictureOfFrontLeftDoorPanel?.url || "");
      setFrontSeatsSrc(one.frontSeats?.url || "");
      setInteriorColor(one.interiorColour || "");
      setRearLeftDoorSrc(one.pictureOfRearLeftDoorPanel?.url || "");
      setRearSeatsSrc(one.rearSeats?.url || "");
      setBootInteriorSrc(one.pictureOfBootInterior?.url || "");
      setRearRightDoorSrc(one.pictureOfRearRightSidePanel?.url || "");
      setFrontDashSrc(one.pictureOfFrontDash?.url || "");
      setInteriorCeilingSrc(one.pictureOfInteriorCeiling?.url || "");
      setInteriorType(one.interiorType || "");
      setFrontRightDoorSrc(one.pictureOfFrontRightSidePanel?.url || "");
      setOdometerSrc(one.pictureOfMileage?.url || "");
      setMileage(`${one.mileage}` || "");
      setExteriorGrade(one.exterior || "");
      setInteriorGrade(one.interior || "");
      let temp: string[] = [];
      if (one.hasAircon) {
        temp.push("Aircon");
      }
      if (one.hasAirbags) {
        temp.push("Airbags");
      }
      if (one.hasAlarmImmobilizer) {
        temp.push("Alarm immobilizer");
      }
      if (one.hasBluetooth) {
        temp.push("Bluetooth");
      }
      if (one.hasElectricWindows) {
        temp.push("Electric windows");
      }
      if (one.hasBrandingWrapRemoval) {
        temp.push("Branding wrap removal");
      }
      if (one.hasCdPlayer) {
        temp.push("CD player");
      }
      if (one.hasCdChanger) {
        temp.push("CD changer");
      }
      if (one.hasCarpets) {
        temp.push("Carpets");
      }
      if (one.radio) {
        temp.push("Radio");
      }
      if (one.hasCellPhoneKit) {
        temp.push("Cellphone kit");
      }
      if (one.hasRunningBoards) {
        temp.push("Running boards");
      }
      if (one.hasClimateControl) {
        temp.push("Climate control");
      }
      if (one.hasMediaInterface) {
        temp.push("Media interface");
      }
      if (one.hasNavigation) {
        temp.push("Navigation");
      }
      if (one.hasSmashAndGrab) {
        temp.push("Smash and grab");
      }
      if (one.hasXenonLights) {
        temp.push("Xenon lights");
      }
      if (one.hasDvdPlayer) {
        temp.push("DVD Player");
      }
      if (one.hasNudgeBar) {
        temp.push("Nudge bar");
      }
      setAccessories(temp);
      setStep(currentStep ? parseInt(currentStep) : 0);
      setInspectId(currentId || "");
      setIsLoading(false);
    } else {
      // docSnap.data() will be undefined in this case
      console.log("No such document!");
      setIsLoading(false);
    }
  };

  const handleScannerClose = () => {
    codeReader.reset();
    setBarCodeScannerOpen(false);
  };

  const handleSignatureClose = () => {
    setSignatureOpen(false);
  };

  const informationText = [
    "1) Certificate of registration",
    "2) Operator card",
    "3) Roadworthy disc",
    "4) Clean vehicle",
    "5) 5MB camera",
    "6) Enough light - no night ",
  ];

  const interiorTypeMenu = ["Material", "Leather", "Pleather"];

  const vehicleHistoryMenu = ["New", "Used", "Built Up"];

  const vehicleTypeMenu = [
    "Sedan",
    "Hatch back",
    "SUV",
    "7 - Seater",
    "9 - Seater",
  ];

  const gradeItems = ["Bad", "Poor", "Fair", "Good", "Great"];

  enum Steps {


  }

  const onCreateUser = async () => {
    setIsLoading(true);
    await createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        setUserId(user.uid);
        addUserData(user.uid);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        const errorCode = error.code;
        const errorMessage = getErrorMessage(errorCode);
        showToast(errorMessage, "error");
      });
  };

  const addUserData = async (uid: string) => {
    setIsLoading(true);
    try {
      let userData: UserType = {
        uid: uid,
        email: email,
        name: firstName,
        surname: lastName,
        phoneNumber: phoneNumber,
      };
      const docRef = await updateDoc(doc(db, `users/${uid}`), userData as FireBaseDataUpdate);
      console.log(docRef);
      setIsLoading(false);
      // setStep((preStep) => preStep + 1);
    } catch (e) {
      setIsLoading(false);
      showToast("Something went long", "error");
    }
  };

  const addUserInspectionsData = async () => {
    setIsLoading(true);
    setCurrentTimeStamp(new Date().getTime());
    let inspectionData: InspectionsType = {
      location: location,
      numberPlate: licenseNumber,
      vin: vin,
      engineNumber: engineNumber,
      year: vehicleYear,
      vehicleHistory: vehicleHistory,
      vehicleTareWeight: Number(vehicleTareWeight),
      vehicleType: vehicleType,
      operatorCard: cardNumber,
      make: make,
      model: model,
      vehicleBarcode: barCode,
      uid: "",
      paid: false,
      createdBy: userId,
      inspectionDate: new Date().getTime(),
      lastRoadworthyTestString: expireDate,
      finished: false,
    };
    const docRef = await addDoc(
      collection(db, `users/${userId}/inspections`),
      inspectionData
    );
    setInspectId(docRef.id);
    setIsLoading(false);
    //setStep((preStep) => preStep + 1);
  };

  const getUserlocation = () => {
    if ("geolocation" in navigator) {
      // Prompt user for permission to access their location
      navigator.geolocation.getCurrentPosition(
        // Success callback function
        (position) => {
          // Get the user's latitude and longitude coordinates
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // Do something with the location data, e.g. display on a map
          setLatitude(lat);
          setLongitude(lng);
        },
        // Error callback function
        (error) => {
          // Handle errors, e.g. user denied location sharing permissions
          console.error("Error getting user location:", error);
        }
      );
    } else {
      // Geolocation is not supported by the browser
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const getImageData = (image: string, type: string, size: number) => {
    let imageData: ImageType = {
      basePath: basePicturePath,
      createdAt: new Date(),
      name: `${type}/${Date.now()}`,
      size: size,
      thumbUrl: image,
      type: "image/png",
      url: image,
      exifdata: {
        BrowserLocation: {
          lat: latitude,
          lng: longitude,
        },
        MakerNote: "",
      },
    };
    return imageData;
  };

  const uploadImage = async (imageData: ImageType, type: InspectionPictureType) => {
    setIsLoading(true)
    const imageKey = InspectionPictureLocations[type]
    if (!imageKey) { return }
    let inspectionData: Partial<InspectionsType> = {}

    inspectionData[imageKey] = imageData;

    // console.log(`Updating document  users/${userId}/inspections/${!isEmpty(inspectId) ? inspectId : currentId}`)
    await updateDoc(
      doc(
        db,
        `users/${userId}/inspections/${!isEmpty(inspectId) ? inspectId : currentId
        }`
      ),
      inspectionData
    );
    setIsLoading(false)

  }

  const updateUserInspectionsData = async () => {
    setIsLoading(true);
    let inspectionData: InspectionsType = {
      location: location,
      numberPlate: licenseNumber,
      vin: vin,
      engineNumber: engineNumber,
      year: vehicleYear,
      vehicleHistory: vehicleHistory,
      vehicleTareWeight: Number(vehicleTareWeight),
      vehicleType: vehicleType,
      operatorCard: cardNumber,
      make: make,
      model: model,
      uid: !isEmpty(inspectId) ? inspectId : currentId || "",
      paid: false,

      vehicleBarcode: barCode,
      mileage: Number(mileage),
      interiorColour: interiorColor,
      interiorType: interiorType,
      interior: interiorGrade,
      exterior: exteriorGrade,
      ...(!isEmpty(vehicleColor) && { colour: vehicleColor }),
      ...(accessories.length > 0 && {
        hasAirbags: accessories.includes("Airbags"),
      }),
      ...(accessories.length > 0 && {
        hasAircon: accessories.includes("Aircon"),
      }),
      ...(accessories.length > 0 && {
        hasAlarmImmobilizer: accessories.includes("Alarm immobilizer"),
      }),
      ...(accessories.length > 0 && {
        hasBluetooth: accessories.includes("Bluetooth"),
      }),
      ...(accessories.length > 0 && {
        hasBrandingWrapRemoval: accessories.includes("Branding wrap removal"),
      }),
      ...(accessories.length > 0 && {
        hasCarpets: accessories.includes("Carpets"),
      }),
      ...(accessories.length > 0 && {
        hasCdChanger: accessories.includes("CD changer"),
      }),
      ...(accessories.length > 0 && {
        hasCdPlayer: accessories.includes("CD player"),
      }),
      ...(accessories.length > 0 && {
        hasCellPhoneKit: accessories.includes("Cellphone kit"),
      }),
      ...(accessories.length > 0 && {
        hasClimateControl: accessories.includes("Climate control"),
      }),
      ...(accessories.length > 0 && {
        hasDvdPlayer: accessories.includes("DVD Player"),
      }),
      ...(accessories.length > 0 && {
        hasElectricWindows: accessories.includes("Electric windows"),
      }),
      ...(accessories.length > 0 && {
        hasMP3Player: accessories.includes("MP3 Player"),
      }),
      ...(accessories.length > 0 && {
        hasMediaInterface: accessories.includes("Media interface"),
      }),
      ...(accessories.length > 0 && {
        hasNavigation: accessories.includes("Navigation"),
      }),
      ...(accessories.length > 0 && {
        hasNudgeBar: accessories.includes("Nudge bar"),
      }),
      hasPanoramicRoof: hasPanoramicRoof,
      hasRoofRack: hasRoofRack,
      ...(accessories.length > 0 && {
        hasRunningBoards: accessories.includes("Running boards"),
      }),
      ...(accessories.length > 0 && {
        hasSmashAndGrab: accessories.includes("Smash and grab"),
      }),
      hasSunRoof: hasSunRoof,
      ...(accessories.length > 0 && {
        hasXenonLights: accessories.includes("Xenon lights"),
      }),
      ...(accessories.length > 0 && { radio: accessories.includes("Radio") }),
      createdBy: userId,
      inspectionDate: currentTimeStamp,
      lastRoadworthyTest: new Date(expireDate).getTime(),
      lastRoadworthyTestString: expireDate,
      finished: false,
    };


    console.log('Updating document')
    await updateDoc(
      doc(
        db,
        `users/${userId}/inspections/${!isEmpty(inspectId) ? inspectId : currentId
        }`
      ),
      inspectionData as FireBaseDataUpdate
    );


    const docRef =
      setStep((preStep) => preStep + 1);
    setIsLoading(false);
  };

  const isValidateForm = () => {
    if (isEmpty(location)) {
      showToast("please input locaiton", "error");
      return false;
    }
    if (isEmpty(licenseNumber)) {
      showToast("please input vehicle license number", "error");
      return false;
    }
    if (isEmpty(vin)) {
      showToast("please input VIN", "error");
      return false;
    }
    if (isEmpty(engineNumber)) {
      showToast("please input engine number", "error");
      return false;
    }
    if (isEmpty(vehicleTareWeight)) {
      showToast("please input vehicle tare weight", "error");
      return false;
    }
    if (isEmpty(vehicleHistory)) {
      showToast("please input vehicle history", "error");
      return false;
    }
    if (isEmpty(vehicleYear)) {
      showToast("please input vehicle year", "error");
      return false;
    }

    if (isEmpty(vehicleType)) {
      showToast("please input vehicle type", "error");
      return false;
    }
    if (isEmpty(cardNumber)) {
      showToast("please input operator card number", "error");
      return false;
    }
    if (isEmpty(make)) {
      showToast("please input make", "error");
      return false;
    }
    if (isEmpty(model)) {
      showToast("please input model", "error");
      return false;
    }
    return true;
  };

  const handleAccessories = (accessory: string) => {
    let temp = [...accessories];
    if (temp.includes(accessory)) {
      temp = temp.filter(function (item) {
        return item !== accessory;
      });
    } else {
      temp.push(accessory);
    }
    setAccessories(temp);
  };

  const acceptInspection = async () => {
    setIsLoading(true);
    let acceptInspectionData: InspectionsType = {
      location: location,
      numberPlate: licenseNumber,
      vin: vin,
      engineNumber: engineNumber,
      year: vehicleYear,
      vehicleHistory: vehicleHistory,
      vehicleTareWeight: Number(vehicleTareWeight),
      vehicleType: vehicleType,
      operatorCard: cardNumber,
      make: make,
      model: model,
      uid: inspectId,
      paid: false,
      vehicleBarcode: barCode,
      mileage: Number(mileage),
      interiorColour: interiorColor,
      interiorType: interiorType,
      interior: interiorGrade,
      exterior: exteriorGrade,
      colour: vehicleColor,
      hasAirbags: accessories.includes("Airbags"),
      hasAircon: accessories.includes("Aircon"),
      hasAlarmImmobilizer: accessories.includes("Alarm immobilizer"),
      hasBluetooth: accessories.includes("Bluetooth"),
      hasBrandingWrapRemoval: accessories.includes("Branding wrap removal"),
      hasCarpets: accessories.includes("Carpets"),
      hasCdChanger: accessories.includes("CD changer"),
      hasCdPlayer: accessories.includes("CD player"),
      hasCellPhoneKit: accessories.includes("Cellphone kit"),
      hasClimateControl: accessories.includes("Climate control"),
      hasDvdPlayer: accessories.includes("DVD Player"),
      hasElectricWindows: accessories.includes("Electric windows"),
      hasMP3Player: accessories.includes("MP3 Player"),
      hasMediaInterface: accessories.includes("Media interface"),
      hasNavigation: accessories.includes("Navigation"),
      hasNudgeBar: accessories.includes("Nudge bar"),
      hasPanoramicRoof: hasPanoramicRoof,
      hasRoofRack: hasRoofRack,
      hasRunningBoards: accessories.includes("Running boards"),
      hasSmashAndGrab: accessories.includes("Smash and grab"),
      hasSunRoof: hasSunRoof,
      hasXenonLights: accessories.includes("Xenon lights"),
      radio: accessories.includes("Radio"),
      createdBy: userId,
      inspectionDate: currentTimeStamp,
      lastRoadworthyTest: new Date(expireDate).getTime(),
      lastRoadworthyTestString: expireDate,
      finished: true,
    };
    const docRef = await updateDoc(
      doc(
        db,
        `users/${userId}/inspections/${!isEmpty(inspectId) ? inspectId : currentId
        }`
      ),
      acceptInspectionData as FireBaseDataUpdate
    );
    setIsLoading(false);
    navigate(`/payments/${!isEmpty(inspectId) ? inspectId : currentId}`);
  };

  const handleColors = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    type: string
  ) => {
    const invalidKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Numpad0",
      "Numpad1",
      "Numpad2",
      "Numpad3",
      "Numpad4",
      "Numpad5",
      "Numpad6",
      "Numpad7",
      "Numpad8",
      "Numpad9",
    ];

    if (invalidKeys.includes(event.target.value.slice(-1))) {
      event.preventDefault();
    } else {
      if (type === "interior") {
        setInteriorColor(event.target.value);
      } else {
        setVehicleColor(event.target.value);
      }
    }
  };

  const getYearFromVinNumber = (aVinNumber: string) => {
    if (aVinNumber) {
      return vehicleYears[aVinNumber] || "-";
    } else {
      return "-";
    }
  };

  const parseBarCodeString = () => {
    const vehicleTypes = [
      "Sedan",
      "Hatch back",
      "SUV",
      "7 - Seater",
      "9 - Seater",
    ];

    const parseString = barCode.trim();
    if (parseString.slice(0, 4) === "%MVL") {
      const pieces = parseString.split("%");
      setLicenseNumber(pieces[6]);
      setCardNumber(pieces[5]);
      setVin(pieces[12]);
      setEngineNumber(pieces[13]);
      const year = getYearFromVinNumber(pieces[12]);
      // if (year) {
      //   setVehicleYear(year);
      // }
      setMake(pieces[9]);
      setModel(pieces[10]);
      setExpireDate(pieces[14]);
      setVehicleColor(pieces[11]);
      const foundVehicleType = vehicleTypes.find((e) =>
        pieces[8].includes(e.split(" ")[0])
      );
      if (foundVehicleType) {
        setVehicleType(foundVehicleType);
      }
    } else if (parseString.slice(0, 4) === "%RC1") {
      const pieces = parseString.split("%");
      setVin(pieces[10]);
      const year = getYearFromVinNumber(pieces[10]);
      if (year) {
        setVehicleYear(year);
      }
      setMake(pieces[8]);
      setModel(pieces[9]);
      const foundVehicleType = vehicleTypes.find((e) =>
        pieces[7].includes(e.split(" ")[0])
      );
      if (foundVehicleType) {
        setVehicleType(foundVehicleType);
      }
      setFirstName(pieces[16].split(" ")[0]);
      setLastName(pieces[16].split(" ")[1]);
    } else if (parseString.length === 13) {
      //  We should probably do some better checking here
      console.log("ID number");
    } else {
      console.log(barCode);
    }
  };

  const handleNext = () => {
    localStorage.clear();
    if (step === 0) {
      if (!isChecked) {
        showToast("Please check information", "error");
      } else {
        setStep((preStep) => preStep + 1);
      }
    } else if (step === 2) {

      // if (!isScaned) {
      //   showToast("Please take scan of your roadworthy disc", "error");
      //   return;
      // }
      if (isEmpty(roadworthyDiscSrc)) {
        showToast("Please take a photo of Roadworthy Disc", "error");
        return;
      }
      if (!isEmpty(barCode)) {
        parseBarCodeString();
      }
      updateUserInspectionsData();
      uploadSignature()

    } else if (step === 3) {
      if (!isLogin) {
        if (isEmpty(roadworthyDiscSrc)) {
          showToast("Please take a photo of Roadworthy Disc", "error");
          return;
        }
        if (!isEmpty(barCode)) {
          parseBarCodeString();
        }
        updateUserInspectionsData();
      } else {
        if (isValidateForm()) updateUserInspectionsData();
      }
    } else if (step === 4) {
      if (isEmpty(certificationImgSrc)) {
        showToast(
          "Please take a photo of Certificate of Registration",
          "error"
        );
        return;
      }
      if (isEmpty(operatorCardSrc)) {
        showToast("Please take a photo of Operator Card", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 5) {
      if (isEmpty(frontRightSrc)) {
        showToast("Please take a photo of 45 degree front right", "error");
        return;
      }
      if (isEmpty(frontRoofSrc)) {
        showToast("Please take a photo of front roof", "error");
        return;
      }
      if (isEmpty(vehicleColor)) {
        showToast("Please input the color of vehicle", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 6) {
      if (isEmpty(frontLeftSrc)) {
        showToast("Please take a photo of 45 degree front left", "error");
        return;
      }
      if (isEmpty(rearLeftSrc)) {
        showToast("Please take a photo of 45 degree rear left", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 7) {
      if (isEmpty(rearRoofSrc)) {
        showToast("Please take a photo of rear roof", "error");
        return;
      }
      if (isEmpty(rearRightSrc)) {
        showToast("Please take a photo of 45 degree rear right", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 8) {
      if (isEmpty(leftDoorSrc)) {
        showToast("Please take a photo of front left door panel", "error");
        return;
      }
      if (isEmpty(frontSeatsSrc)) {
        showToast("Please take a photo of front seats", "error");
        return;
      }
      if (isEmpty(interiorColor)) {
        showToast("Please input the interior color", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 9) {
      if (isEmpty(rearLeftDoorSrc)) {
        showToast("Please take a photo of rear left door panel", "error");
        return;
      }
      if (isEmpty(rearSeatsSrc)) {
        showToast("Please take a photo of rear seats", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 10) {
      if (isEmpty(bootInteriorSrc)) {
        showToast("Please take a photo of boot interior", "error");
        return;
      }
      if (isEmpty(rearRightDoorSrc)) {
        showToast("Please take a photo of rear right door panel", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 11) {
      if (isEmpty(frontDashSrc)) {
        showToast("Please take a photo of front dash", "error");
        return;
      }
      if (isEmpty(interiorCeilingSrc)) {
        showToast("Please take a photo of interior ceiling", "error");
        return;
      }
      if (isEmpty(interiorType)) {
        showToast("Please select the interior type", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 12) {
      if (isEmpty(frontRightDoorSrc)) {
        showToast("Please take a photo of front right door panel", "error");
        return;
      }
      if (isEmpty(odometerSrc)) {
        showToast("Please take a photo of Odometer/Mileage", "error");
        return;
      }
      if (isEmpty(mileage)) {
        showToast("Please input the mileage", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 13) {
      if (accessories.length < 1) {
        showToast("You have to select more than 1 accessory", "error");
        return;
      }
      updateUserInspectionsData();
    } else if (step === 14) {
      if (isEmpty(exteriorGrade)) {
        showToast("You have to select the exterior grade", "error");
        return;
      }
      if (isEmpty(interiorGrade)) {
        showToast("You have to select the interior grade", "error");
        return;
      }
      acceptInspection();
    } else if (step === 1) {
      if (!isLogin) {
        if (isEmpty(firstName)) {
          showToast("Please input your first name", "error");
          return;
        }
        if (isEmpty(lastName)) {
          showToast("Please input your last name", "error");
          return;
        }
        if (isEmpty(email)) {
          showToast("Please input your email address", "error");
          return;
        }
        if (isEmpty(confirmEmail)) {
          showToast("Please confirm your email address", "error");
          return;
        }
        if (isEmpty(password)) {
          showToast("Please input your password", "error");
          return;
        }
        if (isEmpty(confirmPassword)) {
          showToast("Please confirm your password", "error");
          return;
        }
        if (isEmpty(phoneNumber)) {
          showToast("Please input your phone number", "error");
          return;
        }
        if (email !== confirmEmail) {
          showToast(
            "The email address is not matched with your confirm email adress",
            "error"
          );
          return;
        }
        if (password !== confirmPassword) {
          showToast(
            "The password is not matched with your confirm password.",
            "error"
          );
          return;
        }
        onCreateUser();
      } else {

        if (isEmpty(signatureData)) {
          showToast("You have to sign your signature", "error");
          return;
        }
        if (!isCheckedLegal) {
          showToast(
            "You have to check the information and accept the legal and consent",
            "error"
          );
          return;
        }

        setStep((preStep) => preStep + 1);

      }

    } else {
      setStep((preStep) => preStep + 1);
    }
  };

  const handleClear = () => {
    const signaturePad = signaturePadRef.current;
    if (signaturePad) {
      signaturePad.instance.clear();
    }
  };

  const handleSave = () => {
    const signaturePad = signaturePadRef.current;
    if (!signaturePad) {
      return;
    }
    if (signaturePad.isEmpty()) {
      showToast("Please provide a signature first.", "error");
    } else {

      // {todo} Upload the signature instead of getting the data url 
      setSignatureData(signaturePad.toDataURL());
      setIsSigned(true);
      setSignatureOpen(false);
    }
  };

  const uploadSignature = async () => {

    setIsLoading(true);

    const signaturURI = signatureData

    const imageRef = storageRef(
      storage,
      `${basePicturePath}/clientSignature.png`
    );
    const binaryVal = atob(signaturURI.split(',')[1]);

    // Store the bytes of the string to a typed array
    var blobArray = [];
    for (var index = 0; index < binaryVal.length; index++) {
      blobArray.push(binaryVal.charCodeAt(index));
    }

    await uploadBytes(imageRef, new Blob([new Uint8Array(blobArray)]))
    const url = await getDownloadURL(imageRef);
    // console.log(url)
    // {todo} Upload the signature instead of getting the data url 
    setSignatureSrc(url);
    await uploadImage(getImageData(url, 'clientSignature', blobArray.length), InspectionPictureType.clientSignature)


    setIsLoading(false);

  };

  const onGoogleLogin = () => {
    setIsLoading(true);
    signInWithPopup(auth, provider)
      .then(async (result) => {
        setIsLoading(false);
        // const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.accessToken;
        const user = result.user;
        let userData: UserType = {
          uid: result.user.uid,
          email: user.email ? user.email : "",
          name: user.displayName?.split(" ")[0],
          surname: user.displayName?.split(" ")[1],
          phoneNumber: user.phoneNumber || "",
        };
        const docRef = await updateDoc(doc(db, `users/${user.uid}`), userData as FireBaseDataUpdate);
        setUserId(user.uid);
        setEmail(user.email ? user.email : "");
        setFirstName(user.displayName?.split(" ")[0] || "");
        setLastName(user.displayName?.split(" ")[1] || "");
        setPhoneNumber(user.phoneNumber || "");
        // setStep((preStep) => preStep + 1);
      })
      .catch((error) => {
        setIsLoading(false);
        const errorMessage = error.message;
        showToast(errorMessage, "error");
      });
  };

  const information = (
    <Box>
      <Box sx={(theme) => informationContainer(theme)}>
        <Typography sx={(theme) => itemText(theme)}>
          Please ensure you have the following before starting:
        </Typography>
        {informationText.map((one, index) => {
          return (
            <Typography sx={(theme) => itemText(theme)} key={index}>
              {one}
            </Typography>
          );
        })}
      </Box>
      <Box sx={(theme) => termsContainer(theme)}>
        <Typography sx={(theme) => termsText(theme)}>
          I have read and understood the information above
        </Typography>
        <Checkbox
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
      </Box>
    </Box>
  );

  const signup = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <TextField
        placeholder="First Name"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />
      <TextField
        placeholder="Last Name"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />
      <TextField
        placeholder="Email Address"
        size="small"
        fullWidth
        type="email"
        required
        sx={(theme) => input(theme)}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        placeholder="Confirm Email Address"
        size="small"
        fullWidth
        type="email"
        required
        sx={(theme) => input(theme)}
        value={confirmEmail}
        onChange={(e) => setConfirmEmail(e.target.value)}
      />
      <TextField
        placeholder="Password"
        size="small"
        fullWidth
        type="password"
        required
        sx={(theme) => input(theme)}
        value={password}
        onChange={(e) => setPassowrd(e.target.value)}
      />
      <TextField
        placeholder="Confirm Password"
        size="small"
        fullWidth
        type="password"
        required
        sx={(theme) => input(theme)}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <TextField
        placeholder=" Cellphone Number"
        size="small"
        fullWidth
        type="tel"
        required
        sx={(theme) => input(theme)}
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />

      <Divider sx={(theme) => divider(theme)}>or</Divider>

      <Button
        fullWidth
        variant="contained"
        sx={(theme) => authButton(theme)}
        onClick={() => {
          localStorage.setItem("step", "1");
          navigate("/login");
        }}
      >
        Existing User
      </Button>

      <Divider sx={(theme) => divider(theme)}>or continue with</Divider>

      <Button
        fullWidth
        variant="contained"
        startIcon={<GoogleIcon />}
        sx={(theme) => googleButton(theme)}
        onClick={() => {
          onGoogleLogin();
        }}
      >
        Google
      </Button>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "12px",
          color: colors.dark_gray,
          mt: 2,
        }}
      >
        By clicking continue, you agree to our{" "}
        <b style={{ color: "black" }}>Terms of Service</b> and{" "}
        <b style={{ color: "black" }}>Privacy Policy</b>
      </Typography>
    </Box>
  );

  const input2 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <Select
        labelId="location-select-label"
        id="locaiton-select"
        value={location}
        onChange={(event) => setLocation(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white" }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Location
              </em>
            );
          }

          return selected;
        }}
      >
        {locationList.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>

      <TextField
        placeholder="Vehicle License Number"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={licenseNumber}
        onChange={(e) => setLicenseNumber(e.target.value)}
      />
      <TextField
        placeholder="VIN"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={vin}
        onChange={(e) => setVin(e.target.value)}
      />
      <TextField
        placeholder="Engine Number"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={engineNumber}
        onChange={(e) => setEngineNumber(e.target.value)}
      />
      <TextField
        placeholder="Vehicle Tare Weight"
        size="small"
        fullWidth
        type="number"
        required
        sx={(theme) => input(theme)}
        value={vehicleTareWeight}
        onChange={(e) => setVehicleTareWeight(e.target.value)}
      />
      <Select
        labelId="history-select-label"
        id="history-select"
        value={vehicleHistory}
        onChange={(event) => setVehicleHistory(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Vehicle History
              </em>
            );
          }

          return selected;
        }}
      >
        {vehicleHistoryMenu.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>
      <Select
        labelId="year-select-label"
        id="year-select"
        value={vehicleYear}
        onChange={(event) => setVehicleYear(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Vehicle Year
              </em>
            );
          }

          return selected;
        }}
      >
        {vehicleYearList.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>
      <Select
        labelId="type-select-label"
        id="type-select"
        value={vehicleType}
        onChange={(event) => setVehicleType(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Vehicle Type
              </em>
            );
          }

          return selected;
        }}
      >
        {vehicleTypeMenu.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>
      <TextField
        placeholder="Operator Card Number"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={cardNumber}
        onChange={(e) => setCardNumber(e.target.value)}
      />
      <TextField
        placeholder="Make"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={make}
        onChange={(e) => setMake(e.target.value)}
      />
      <TextField
        placeholder="Model"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={model}
        onChange={(e) => setModel(e.target.value)}
      />
      <TextField
        placeholder="Expiry Date"
        size="small"
        fullWidth
        type="date"
        required
        sx={(theme) => input(theme)}
        value={expireDate}
        onChange={(e) => setExpireDate(e.target.value)}
      />
    </Box>
  );

  const input3 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={CertiSampleImg}
        webcamType={InspectionPictureType[InspectionPictureType.certificateOfRegistration]}
        pictureType={InspectionPictureType.certificateOfRegistration}
        imageSrc={certificationImgSrc}
        title="Certificate of Registration"
        updateSrc={setCertificationImgSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={OperatorCardSampleImg}
        webcamType={InspectionPictureType[InspectionPictureType.operatorCard]}
        pictureType={InspectionPictureType.operatorCard}
        imageSrc={operatorCardSrc}
        title="Operator Card"
        updateSrc={setOperatorCardSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

    </Box>
  );

  const input1 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <Box sx={(theme) => imageContainer(theme)}>
        <Typography sx={(theme) => subTitle(theme)}>
          Scan Roadworthy Disc
        </Typography>
        <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
          {barCode ? (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                You scanned successfully!
              </Typography>
              <Button
                sx={(theme) => rescanButton(theme)}
                onClick={() => {
                  setBarCodeScannerOpen(true);
                }}
              >
                Rescan
              </Button>
            </Box>
          ) : detectCount < 3 ? (
            <img
              src={BarcodeSampleImg}
              style={{
                height: "180px",
                width: "100%",
                objectFit: "contain",
              }}
              alt="logo"
            />
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Barcode detection failed.
              </Typography>
              <Button
                sx={(theme) => rescanButton(theme)}
                onClick={() => {
                  setBarCodeScannerOpen(true);
                }}
              >
                Rescan
              </Button>
            </Box>
          )}
          {!barCode && detectCount < 3 && (
            <Button
              startIcon={<img src={CameraImg} alt="button" />}
              sx={(theme) => imgButtonContaier(theme)}
              onClick={() => {
                setBarCodeScannerOpen(true);
              }}
            />
          )}
        </Box>
      </Box>
      <ImageUpload
        defaultImageSrc={RoadworthySampleImg}
        webcamType={InspectionPictureType[InspectionPictureType.roadworthyDisc]}
        basePath={basePicturePath}


        imageSrc={roadworthyDiscSrc}
        title="Roadworthy Disc"
        longitude={longitude}
        latitude={latitude}
        updateSrc={setRoadworthyDiscSrc}
        saveImage={uploadImage}
        pictureType={InspectionPictureType.roadworthyDisc}
        capture="environment"
      ></ImageUpload>

    </Box>
  );

  const exteriorFrame1 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={FrontRightImg}
        webcamType={InspectionPictureType[InspectionPictureType.frontRight]}
        basePath={basePicturePath}


        imageSrc={frontRightSrc}
        title="45 degree Front Right"
        longitude={longitude}
        latitude={latitude}
        updateSrc={setFrontRightSrc}
        saveImage={uploadImage}
        pictureType={InspectionPictureType.frontRight}
        capture="environment"
      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={FrontRoofImg}
        webcamType={InspectionPictureType[InspectionPictureType.frontRoof]}
        pictureType={InspectionPictureType.frontRoof}
        imageSrc={frontRoofSrc}
        title="Front Roof"
        updateSrc={setFrontRoofSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <TextField
        placeholder="Vehicle Colour"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={vehicleColor}
        onChange={(e) => handleColors(e, "exterior")}
      />
    </Box>
  );

  const exteriorFrame2 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={FrontLeftImg}
        webcamType={InspectionPictureType[InspectionPictureType.frontLeft]}
        pictureType={InspectionPictureType.frontLeft}
        imageSrc={frontLeftSrc}
        title="45 degree Front Left"
        updateSrc={setFrontLeftSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={RearLeftImg}
        webcamType={InspectionPictureType[InspectionPictureType.rearLeft]}
        pictureType={InspectionPictureType.rearLeft}
        imageSrc={rearLeftSrc}
        title="45 degree Rear Left"
        updateSrc={setRearLeftSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <Box
        sx={{
          color: colors.light_black,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <FormControlLabel
          value="rack"
          control={
            <Checkbox
              checked={hasRoofRack}
              onChange={() => setHasRoofRack(!hasRoofRack)}
            />
          }
          label="Roof Rack"
          labelPlacement="start"
        />
        <FormControlLabel
          value="sun"
          control={
            <Checkbox
              checked={hasSunRoof}
              onChange={() => setHasSunRoof(!hasSunRoof)}
            />
          }
          label="Sun Roof"
          labelPlacement="start"
        />
      </Box>
    </Box>
  );

  const exteriorFrame3 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>

      <ImageUpload
        defaultImageSrc={RearRoofImg}
        webcamType={InspectionPictureType[InspectionPictureType.rearRoof]}
        pictureType={InspectionPictureType.rearRoof}
        imageSrc={rearRoofSrc}
        title="Rear Roof"
        updateSrc={setRearRoofSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={RearRightImg}
        webcamType={InspectionPictureType[InspectionPictureType.rearRight]}
        pictureType={InspectionPictureType.rearRight}
        imageSrc={rearRightSrc}
        title="45 degree Rear Right"
        updateSrc={setRearRightSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <Box
        sx={{
          color: colors.light_black,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <FormControlLabel
          value="panoramic"
          control={
            <Checkbox
              checked={hasPanoramicRoof}
              onChange={() => setHasPanoramicRoof(!hasPanoramicRoof)}
            />
          }
          label="Panoramic Roof"
          labelPlacement="start"
        />
      </Box>
    </Box>
  );

  const interiorFrame1 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={FrontLeftDoorImg}
        webcamType={InspectionPictureType[InspectionPictureType.frontLeftDoor]}
        pictureType={InspectionPictureType.frontLeftDoor}
        imageSrc={leftDoorSrc}
        title="Front Left Door Panel"
        updateSrc={setLeftDoorSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={FrontSeatsImg}
        webcamType={InspectionPictureType[InspectionPictureType.frontSeats]}
        pictureType={InspectionPictureType.frontSeats}
        imageSrc={frontSeatsSrc}
        title="Front Seats"
        updateSrc={setFrontSeatsSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <TextField
        placeholder="Interior Colour"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={interiorColor}
        onChange={(e) => handleColors(e, "interior")}
      />
    </Box>
  );

  const interiorFrame2 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>

      <ImageUpload
        defaultImageSrc={RearLeftDoorImg}
        webcamType={InspectionPictureType[InspectionPictureType.rearLeftDoor]}
        pictureType={InspectionPictureType.rearLeftDoor}
        imageSrc={rearLeftDoorSrc}
        title="Rear Left Door Panel"
        updateSrc={setRearLeftDoorSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={RearSeatsImg}
        webcamType={InspectionPictureType[InspectionPictureType.rearSeats]}
        pictureType={InspectionPictureType.rearSeats}
        imageSrc={rearSeatsSrc}
        title="Rear Seats"
        updateSrc={setRearSeatsSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

    </Box>
  );

  const interiorFrame3 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>

      <ImageUpload
        defaultImageSrc={BootInteriorImg}
        webcamType={InspectionPictureType[InspectionPictureType.bootInterior]}
        pictureType={InspectionPictureType.bootInterior}
        imageSrc={bootInteriorSrc}
        title="Boot Interior"
        updateSrc={setBootInteriorSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={RearRightDoorImg}
        webcamType={InspectionPictureType[InspectionPictureType.rearRightDoor]}
        pictureType={InspectionPictureType.rearRightDoor}
        imageSrc={rearRightDoorSrc}
        title="Rear Right Door Panel"
        updateSrc={setRearRightDoorSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

    </Box>
  );

  const interiorFrame4 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={FrontDashImg}
        webcamType={InspectionPictureType[InspectionPictureType.frontDash]}
        pictureType={InspectionPictureType.frontDash}
        imageSrc={frontDashSrc}
        title="Front Dash"
        updateSrc={setFrontDashSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={InteriorCeilingImg}
        webcamType={InspectionPictureType[InspectionPictureType.interiorCeiling]}
        pictureType={InspectionPictureType.interiorCeiling}
        imageSrc={interiorCeilingSrc}
        title="Interior Ceiling"
        updateSrc={setInteriorCeilingSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <Select
        labelId="interior-type-select-label"
        id="interior-type-select"
        value={interiorType}
        onChange={(event) => setInteriorType(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 2 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Interior Type
              </em>
            );
          }
          return selected;
        }}
      >
        {interiorTypeMenu.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );

  const interiorFrame5 = (
    <Box sx={{ width: "100%", p: "20px 0" }}>

      <ImageUpload
        defaultImageSrc={FrontRightDoorImg}
        webcamType={InspectionPictureType[InspectionPictureType.frontRightDoor]}
        pictureType={InspectionPictureType.frontRightDoor}
        imageSrc={frontRightDoorSrc}
        title="Front Right Door Panel"
        updateSrc={setFrontRightDoorSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={OdometerImg}
        webcamType={InspectionPictureType[InspectionPictureType.odometer]}
        pictureType={InspectionPictureType.odometer}
        imageSrc={odometerSrc}
        title="Odometer / Mileage"
        updateSrc={setOdometerSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <TextField
        placeholder="Mileage"
        size="small"
        fullWidth
        type="number"
        required
        sx={(theme) => input(theme)}
        value={mileage}
        onChange={(e) => setMileage(e.target.value)}
      />
    </Box>
  );

  const accessoriesFrame = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      {accessoryItems.map((accessory, index) => {
        return (
          <Box sx={(theme) => checkBoxContainer(theme)} key={index}>
            <Typography sx={(theme) => checkBoxText(theme)}>
              {accessory}
            </Typography>
            <Checkbox
              checked={accessories.includes(accessory)}
              sx={{ p: "5px" }}
              onChange={(e) => handleAccessories(accessory)}
            />
          </Box>
        );
      })}
    </Box>
  );

  const gradeFrame = (
    <Box sx={{ width: "100%", p: "20px 0 300px 0" }}>
      <Box sx={(theme) => titleContainer(theme)}>
        <Typography sx={(theme) => subTitle(theme)}>Exterior Grade</Typography>
      </Box>
      <Box sx={(theme) => gradeItemContainer(theme)}>
        {gradeItems.map((one, index) => {
          return (
            <Box
              key={index}
              sx={{ alignItems: "center", justifyContent: "center" }}
            >
              <Checkbox
                sx={{ p: "5px" }}
                checked={exteriorGrade === one}
                onChange={() => setExteriorGrade(one)}
              />
              <Typography sx={(theme) => gradeText(theme)}>{one}</Typography>
            </Box>
          );
        })}
      </Box>
      <Box sx={(theme) => titleContainer(theme)}>
        <Typography sx={(theme) => subTitle(theme)}>Interior Grade</Typography>
      </Box>
      <Box sx={(theme) => gradeItemContainer(theme)}>
        {gradeItems.map((one, index) => {
          return (
            <Box
              key={index}
              sx={{ alignItems: "center", justifyContent: "center" }}
            >
              <Checkbox
                sx={{ p: "5px" }}
                checked={interiorGrade === one}
                onChange={() => setInteriorGrade(one)}
              />
              <Typography sx={(theme) => gradeText(theme)}>{one}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );

  const legalFrame = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <Box sx={(theme) => legalContainer(theme)}>
        <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>
          12 Consent Form Templates to Always Have on Hand When Doing Business
        </Typography>
        <Typography variant="body2">
          When running a business, you need a number of legal documents in your
          arsenal. Having the right legal documentation is critical for ensuring
          compliance with applicable laws and regulations. They also protect
          your business's interests, shielding it from potential legal issues
          like lawsuits, penalties, hefty fines and fees. One essential legal
          document most businesses often neglect is consent forms. Consent forms
          are used to legally obtain permission to perform certain actions,
          ensuring that all parties involved fully understand the terms and
          conditions of the agreement. Maybe you're wondering how consent forms
          might come into play in your business and how to create them properly.
          This article will explore everything you need to know about consent
          forms. We’ve also included 12 consent form templates you should have
          on hand while doing business. Before we dive in, here’s a short
          selection of 8 easy-to-edit consent form templates you can edit, share
          and download with Visme. View more templates below:
        </Typography>
        <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>
          What Is a Consent Form?
        </Typography>
        <Typography variant="body2">
          A consent form is a document used to obtain permission from an
          individual or parties to perform certain actions or engage in
          activities. The form indicates that the signatory understands the
          associated terms and cannot hold the other party liable for any injury
          or harm. The purpose of a consent form is to: Inform individuals or
          parties about a particular activity or procedure. Ensure that
          participants are fully aware of the risks and benefits associated with
          a particular activity or procedure. Obtain their voluntary agreement
          or consent to participate in it. Provide them with the opportunity to
          ask questions before deciding whether or not to participate. Consent
          forms are useful in business, marketing, finance, law, psychology,
          social sciences and education. Also, they are commonly used in medical
          research, clinical trials, and other healthcare-related activities.
        </Typography>
        <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>
          The Importance of Using a Consent Form
        </Typography>
        <Typography variant="body2">
          A consent form is a document used to obtain permission from an
          individual or parties to perform certain actions or engage in
          activities. The form indicates that the signatory understands the
          associated terms and cannot hold the other party liable for any injury
          or harm. The purpose of a consent form is to: Inform individuals or
          parties about a particular activity or procedure. Ensure that
          participants are fully aware of the risks and benefits associated with
          a particular activity or procedure. Obtain their voluntary agreement
          or consent to participate in it. Provide them with the opportunity to
          ask questions before deciding whether or not to participate. Consent
          forms are useful in business, marketing, finance, law, psychology,
          social sciences and education. Also, they are commonly used in medical
          research, clinical trials, and other healthcare-related activities.
        </Typography>
      </Box>
      <Box sx={(theme) => signatureContainer(theme)}>
        {!isSigned && (
          <Button
            variant="contained"
            sx={(theme) => backButton(theme)}
            onClick={() => {
              setSignatureOpen(true);
            }}
          >
            SIGN
          </Button>
        )}
        {isSigned && (
          <img
            src={signatureSrc || signatureData}
            alt="signaure"
            width={300}
            style={{ objectFit: "contain" }}
          />
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 3,
          mb: 3,
        }}
      >
        <Typography sx={(theme) => checkBoxText(theme)}>
          I have read and understood the information and accept above
        </Typography>
        <Checkbox
          checked={isCheckedLegal}
          onChange={(e) => setIsCheckedLegal(!isCheckedLegal)}
        />
      </Box>
    </Box>
  );

  return (
    <Box sx={(theme) => container(theme)}>
      <Box sx={(theme) => bodyContainer(theme)}>
        {!isLogin && (
          <Box sx={(theme) => subContainer(theme)}>
            <Typography sx={(theme) => titleText(theme)}>
              {step === 0
                ? "Information"
                : step === 1
                  ? "User Information"
                  : step === 2
                    ? "Vehicle Information"
                    : step === 3
                      ? "Documents"
                      : step === 4
                        ? "Documents"
                        : ""}
            </Typography>
            {step === 0 && information}

            {step === 1 && signup}

            {step === 2 && input1}

            {step === 3 && input2}

            {step === 4 && input3}

            <Box sx={(theme) => buttonContainer(theme)}>
              <Button
                variant="contained"
                sx={(theme) => backButton(theme)}
                onClick={() => {
                  if (step === 0) {
                    navigate("/services");
                  } else {
                    setStep((preStep) => preStep - 1);
                  }
                }}
              // disabled={step < 1}
              >
                Back
              </Button>

              <Button
                variant="contained"
                sx={(theme) => nextButton(theme)}
                onClick={() => handleNext()}
                disabled={isLoading}
              >
                Next
              </Button>
            </Box>
            <LinearProgress
              value={
                step === 0
                  ? 0
                  : step === 1
                    ? 25
                    : step === 2
                      ? 50
                      : step === 3
                        ? 75
                        : step === 4
                          ? 100
                          : 0
              }
              variant="determinate"
              sx={(theme) => borderLinearProgress(theme)}
            />
          </Box>
        )}
        {isLogin && (
          <Box sx={(theme) => subContainer(theme)}>
            <Typography sx={(theme) => titleText(theme)}>
              {step === 0
                ? "Information"
                : step === 1
                  ? "Legal and Consent"
                  : step === 2
                    ? "Vehicle Information"
                    : step === 3
                      ? "Documents"
                      : step === 4
                        ? "Documents"
                        : step === 5 || step === 6 || step === 7
                          ? "Exterior pictures"
                          : step === 8 ||
                            step === 9 ||
                            step === 10 ||
                            step === 11 ||
                            step === 12
                            ? "Interior pictures"
                            : step === 13
                              ? "Accessories"
                              : step === 14
                                ? "Vehicle Grade"
                                : ""}
            </Typography>
            {step === 0 && information}
            {step === 1 && legalFrame}
            {step === 2 && input1}
            {step === 3 && input2}
            {step === 4 && input3}
            {step === 5 && exteriorFrame1}
            {step === 6 && exteriorFrame2}
            {step === 7 && exteriorFrame3}
            {step === 8 && interiorFrame1}
            {step === 9 && interiorFrame2}
            {step === 10 && interiorFrame3}
            {step === 11 && interiorFrame4}
            {step === 12 && interiorFrame5}
            {step === 13 && accessoriesFrame}
            {step === 14 && gradeFrame}

            <Box sx={(theme) => buttonContainer(theme)}>
              <Button
                variant="contained"
                sx={(theme) => backButton(theme)}
                onClick={() => {
                  if (step === 0) {
                    navigate("/services");
                  } else {
                    setStep((preStep) => preStep - 1);
                  }
                }}
              // disabled={step < 1}
              >
                Back
              </Button>

              <Button
                variant="contained"
                sx={(theme) =>
                  step === 14 ? acceptButton(theme) : nextButton(theme)
                }
                onClick={() => handleNext()}
              // disabled={step > 3}
              >
                {step === 14 ? "Accept" : "Next"}
                {isLoading && (
                  <CircularProgress size={30} sx={{ ml: 1, color: "white" }} />
                )}
              </Button>
            </Box>
            <LinearProgress
              value={step === 0 ? 0 : (100 / 15) * step}
              variant="determinate"
              sx={(theme) => borderLinearProgress(theme)}
            />
          </Box>
        )}
        <Modal
          open={barCodeScannerOpen}
          onClose={handleScannerClose}
          aria-labelledby="scanner-modal-title"
          aria-describedby="scanner-modal-description"
        >
          <Box sx={(theme) => modalContainer(theme)}>
            <BarCodeReader
              setBarCode={setBarCode}
              setOpen={setBarCodeScannerOpen}
              setDetectCount={setDetectCount}
              setIsScaned={setIsScaned}
              codeReader={codeReader}
            />
          </Box>
        </Modal>
        <Modal
          open={signatureOpen}
          onClose={handleSignatureClose}
          aria-labelledby="parent-modal-title"
          aria-describedby="parent-modal-description"
        >
          <Box sx={(theme) => modalContainer(theme)}>
            <SignaturePad
              ref={signaturePadRef}
              height={250}
              options={{
                minWidth: 1,
                maxWidth: 1,
                penColor: "black",
              }}
              debounceInterval={1}
              redrawOnResize
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Button
                variant="contained"
                sx={(theme) => clearButton(theme)}
                onClick={() => handleClear()}
              >
                Clear
              </Button>
              <Button
                variant="contained"
                sx={(theme) => saveButton(theme)}
                onClick={() => handleSave()}
              >
                Save
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
      {isLoading && <LoadingView />}
    </Box>
  );
};

export default UserInformation;
